import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getResourceProperties, } from 'ziphy-web-shared/basic/entities/notes/resources';
import { joinValuesToString } from 'ziphy-web-shared/basic/helpers';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
export function useResourceBlock($block, data) {
    const { t } = useTranslation();
    return useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        const { resourceContext } = $block;
        const { resourceType, element } = resourceContext;
        if (resourceType === 'AllergyIntolerance') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            return {
                ModalComponent: properties.ModalComponent,
                code: (_a = extractor.code) === null || _a === void 0 ? void 0 : _a.code,
                value: (_b = extractor.code) === null || _b === void 0 ? void 0 : _b.display,
                meta: joinValuesToString([(_c = extractor.type) === null || _c === void 0 ? void 0 : _c.title, extractor.note], ' • '),
                rightValue: null,
                rightMeta: joinValuesToString([(_d = extractor.status) === null || _d === void 0 ? void 0 : _d.title, (_e = extractor.verificationStatus) === null || _e === void 0 ? void 0 : _e.title], ' • '),
            };
        }
        if (resourceType === 'Condition') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            return {
                ModalComponent: properties.ModalComponent,
                code: (_f = extractor.code) === null || _f === void 0 ? void 0 : _f.code,
                value: (_g = extractor.code) === null || _g === void 0 ? void 0 : _g.display,
                // meta: joinValuesToString(
                //   [extractor.onset?.title, extractor.severity?.title, extractor.note],
                //   ' • ',
                // ),
                rightValue: null,
                rightMeta: joinValuesToString([(_h = extractor.status) === null || _h === void 0 ? void 0 : _h.title, (_j = extractor.verificationStatus) === null || _j === void 0 ? void 0 : _j.title], ' • '),
            };
        }
        if (resourceType === 'MedicationStatement') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            return {
                ModalComponent: properties.ModalComponent,
                code: (_k = extractor.code) === null || _k === void 0 ? void 0 : _k.code,
                value: (_l = extractor.code) === null || _l === void 0 ? void 0 : _l.display,
                meta: joinValuesToString([(_m = extractor.frequency) === null || _m === void 0 ? void 0 : _m.title, extractor.note], ' • '),
                rightValue: null,
                rightMeta: (_o = extractor.status) === null || _o === void 0 ? void 0 : _o.title,
            };
        }
        if (resourceType === 'MedicationRequest') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            return {
                ModalComponent: properties.ModalComponent,
                code: (_p = extractor.code) === null || _p === void 0 ? void 0 : _p.code,
                value: (_q = extractor.code) === null || _q === void 0 ? void 0 : _q.display,
                meta: joinValuesToString([
                    [`${t('label.effective_date')}: `, formatDate(extractor.data.dispense.valid.start)],
                    [`${t('label.discard_after')}: `, formatDate(extractor.data.dispense.valid.end)],
                    (_r = extractor.frequency) === null || _r === void 0 ? void 0 : _r.title,
                    extractor.note,
                ], ' • '),
                rightValue: null,
                rightMeta: (_s = extractor.status) === null || _s === void 0 ? void 0 : _s.title,
            };
        }
        if (resourceType === 'Procedure') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            let meta = null;
            if (element !== 'procedure.billable') {
                meta = joinValuesToString([(_t = extractor.date) === null || _t === void 0 ? void 0 : _t.asString, extractor.note], ' • ');
            }
            return {
                ModalComponent: properties.ModalComponent,
                code: (_u = extractor.code) === null || _u === void 0 ? void 0 : _u.code,
                value: (_v = extractor.code) === null || _v === void 0 ? void 0 : _v.display,
                meta: meta,
                rightValue: null,
                rightMeta: null,
            };
        }
        if (resourceType === 'Immunization') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            return {
                ModalComponent: properties.ModalComponent,
                code: (_w = extractor.code) === null || _w === void 0 ? void 0 : _w.code,
                value: (_x = extractor.code) === null || _x === void 0 ? void 0 : _x.display,
                meta: extractor.note,
                rightValue: null,
                rightMeta: (_y = extractor.status) === null || _y === void 0 ? void 0 : _y.title,
            };
        }
        if (resourceType === 'ServiceRequest') {
            const context = resourceContext;
            const properties = getResourceProperties(context);
            const extractor = new properties.extractor(data);
            if (element === 'request.visit.ziphy' || element === 'request.visit.pcp') {
                return {
                    ModalComponent: properties.ModalComponent,
                    code: null,
                    value: $block.title,
                    meta: joinValuesToString([
                        extractor.date ? formatDate(extractor.date) : null,
                        (_z = extractor.careTeam) === null || _z === void 0 ? void 0 : _z.title,
                        (_0 = extractor.appointmentType) === null || _0 === void 0 ? void 0 : _0.title,
                        extractor.hasDevice ? t('label.has_device') : '',
                        extractor.hasSkills ? t('label.has_skills') : '',
                        extractor.note,
                    ], ' • '),
                    rightValue: null,
                    rightMeta: null,
                };
            }
            if (element === 'order.lab' || element === 'order.imaging') {
                return {
                    ModalComponent: properties.ModalComponent,
                    code: null,
                    value: joinValuesToString(extractor.data.orderDetail.map((x) => x.text), ', '),
                    meta: joinValuesToString([$block.title, extractor.note], ' • '),
                    rightValue: null,
                    // rightMeta: extractor.status?.title,
                    rightMeta: null,
                };
            }
            return {
                ModalComponent: properties.ModalComponent,
                code: (_1 = extractor.code) === null || _1 === void 0 ? void 0 : _1.code,
                value: (_2 = extractor.code) === null || _2 === void 0 ? void 0 : _2.display,
                meta: joinValuesToString([$block.title, extractor.note], ' • '),
                rightValue: null,
                rightMeta: null,
            };
        }
        return {
            ModalComponent: null,
            code: null,
            value: null,
            meta: null,
            rightValue: null,
            rightMeta: null,
        };
    }, [$block.resourceContext, data]);
}
